// Layout and colors CONSTANTS
export const LIGHT_THEME = 'LIGHT_THEME';
export const DARK_THEME = 'DARK_THEME';
export const THEME_COLOR = 'THEME_COLOR';
export const NAVBAR_BG = 'NAVBAR_BG';
export const SIDEBAR_BG = 'SIDEBAR_BG';
export const DIRECTION = 'DIRECTION';
export const BLUE_THEME = 'BLUE_THEME';
export const GREEN_THEME = 'GREEN_THEME';
export const RED_THEME = 'RED_THEME';
export const BLACK_THEME = 'BLACK_THEME';
export const PURPLE_THEME = 'PURPLE_THEME';
export const INDIGO_THEME = 'INDIGO_THEME';
export const ORANGE_THEME = 'ORANGE_THEME';

// Authentication constants
export const LOGIN_FORM_SUBMITTED = "LOGIN_FORM_SUBMITED";
export const REGISTER_FORM_SUBMITTED = "REGISTER_FORM_SUBMITTED";
export const USER_LOGGED_IN = "USER_LOGGED_IN";
export const USER_REGISTERED = "USER_REGISTERED";
export const USER_CHANGED = "USER_CHANGED";
export const LOGOUT = "LOGOUT";
export const AUTH_ERROR = "AUTHENTICATION_ERROR";
export const AUTH_ERROR_SINGLE = "AUTHENTICATION_ERROR_SINGLE";
export const ERR_PW_MATCH = "PASSWORD_CONFIRMATION_DONT_MATCH";
export const CLR_AUTH_MSGS = "CLEAR_AUTH_MESSAGES";

//Capsule constants
export const SAVE_CAPSULE = "SAVE_CAPSULE";
export const CAPSULE_ERROR = "CAPSULE_ERROR";
export const CLEAR_CAPSULE = "CLEAR_CAPSULE";
export const GET_ALL = "GET_ALL_CAPSULES";
export const LOAD_CAPSULE = "CAPSULE LOADED";
export const CAPSULE_COUNT = "CAPSULE_COUNT";